import { createAction } from 'redux-act'

//State Actions
export const fetchCostList = createAction('Fetch Cost List')
export const fetchCostListSuccessful = createAction('Fetch Cost List Success')
export const fetchCostListFailure = createAction('Fetch Cost List Fail')

export const deleteCostPhoto = createAction('Delete Cost Photo')
export const deleteCostPhotoSuccessful = createAction('Delete Cost Photo Success')
export const deleteCostPhotoFailure = createAction('Delete Cost Photo Fail')

export const addCost = createAction('Add Cost')


//Operation Actions
export const pdfDownload = createAction('Pdf Download')
export const deleteCost = createAction('Delete Cost')
export const setCostFilter = createAction('Set Cost Filter')
export const sendCostApproval = createAction('Send a cost for approvement')
export const manageCostPhotoUpload = createAction('Manage cost photo upload process')
export const costFormValidation = createAction('Validate cost form')
export const addCostPhoto = createAction('Add Cost Photo')
